import constants from 'constants/index'

const statusLabel = (statusId) => {
  if (
    constants.dataProcess.LIA_STATUSES.REVIEW_LIA_STATUSES.includes(statusId)
  ) {
    return constants.dataProcess.REVIEW_LIA_LABEL
  }
  switch (statusId) {
    case constants.dataProcess.PENDING_STATUS:
      return constants.dataProcess.PENDING_LABEL
    case constants.dataProcess.WAITING_REVIEW_STATUS:
      return constants.dataProcess.WAITING_REVIEW_LABEL
    case constants.dataProcess.SOFT_DELETED_STATUS:
      return constants.dataProcess.SOFT_DELETED_LABEL
    case constants.dataProcess.DISAPPROVED_STATUS:
      return constants.dataProcess.DISAPPROVED_LABEL
    case constants.dataProcess.APPROVED_STATUS:
      return constants.dataProcess.APPROVED_LABEL
    case constants.dataProcess.REVIEWING_STATUS:
      return constants.dataProcess.REVIEWING_LABEL
    case constants.dataProcess.INACTIVE_STATUS:
      return constants.dataProcess.INACTIVE_LABEL
    case constants.dataProcess.AUTO_REVIEW_STATUS:
      return constants.dataProcess.AUTO_REVIEW_LABEL
    case constants.dataProcess.LIA_STATUSES.PENDING_LIA_STATUS:
      return constants.dataProcess.PENDING_LIA_LABEL
    case constants.dataProcess.LIA_STATUSES.DISAPPROVED_LIA_STATUS:
      return constants.dataProcess.DISAPPROVED_LIA_LABEL
    default:
      return '-'
  }
}

export default statusLabel
